import axios from "axios";

export const state = {
    payouts: []
};

export const mutations = {
    SET_PAYOUTS (state, newValue) {
        state.payouts = newValue;
    },
    CLEAR (state) {
        state.payouts = {};
    },
};

export const getters = {
    hasPayouts (state) {
        return state.payouts.length
    }
};

export const actions = {
    async getPayoutsData({ commit }) {
        commit('loader/START_LOADING', null, { root: true });
        try{
            const { data } = await axios.get('/admin/influencer/payouts');
            commit('SET_PAYOUTS', data);
        } finally {
            commit('loader/END_LOADING', null, { root: true });
        }
    }
};
